import { render, staticRenderFns } from "./eyedrop.html?vue&type=template&id=4913769a&"
import script from "./eyedrop.ts?vue&type=script&lang=ts&"
export * from "./eyedrop.ts?vue&type=script&lang=ts&"
import style0 from "./eyedrop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports